import { RequirementAction } from './types';

// #132: the method ids accepted by the lookup `requirements.actions` entries of
// one type (SET_RETURN_METHODS / SET_PAYMENT_METHODS). return-api adds one
// entry per rule that matched the order at lookup and, at submit, EVERY
// matching rule refuses a method outside its own list
// (SetReturnMethodsAction.execute), so the accepted set is the INTERSECTION of
// all entries; an entry with an empty list refuses every method. Ids are kept
// as the server's text (`JsonNode.toString()`: 11 -> "11", "11" -> "\"11\"").
// `null` = no entry of that type = no restriction.
//
// Known limitation: an entry carries no rule provenance, so a rule with a
// line_item condition (evaluated over ALL order lines at lookup, over the
// RETURNED lines at submit) is intersected like an order-level one and may
// narrow the list beyond what the server enforces for the chosen lines.
export const acceptedMethodIds = (
  actions: RequirementAction[] | undefined,
  type: RequirementAction['type']
): Set<string> | null => {
  const entries = (actions ?? []).filter(action => action.type === type);
  if (entries.length === 0) return null;
  return entries
    .map(
      entry =>
        new Set(
          (entry.applied ?? []).flatMap(field =>
            (field.values ?? []).map(value => String(value))
          )
        )
    )
    .reduce(
      (common, ids) => new Set(Array.from(common).filter(id => ids.has(id)))
    );
};
